import axios from 'axios';

const baseUrl = 'https://dev.api.b2c.upstrive.de';

export async function verifyAccount(data) {
	const options = {
		method: 'POST',
		url: `${baseUrl}/user/verify/email`,
		data: data,
	};
	return axios(options)
		.then((response) => handleSuccess(response))
		.catch((error) => handleError(error));
}

function handleError(error) {
	return { status: error?.response?.status, data: error?.response?.data };
}
function handleSuccess(response) {
	return { status: response.status, data: response.data };
}
